class StringHelper {

  /**
   * Creates a state key string from passed parameters.
   * @param type Value which tells us which scene the key is for
   * @param resolution Resolution param of the image image
   * @param floor Number of the floor of the image
   * @param row Number of the row of the image
   */
  makeStateKey(type, resolution, floor, row) {
    return `${type}_${resolution}_${floor}_${row}`;
  }

  /**
   * Creates image key string from passed parameters.
   * @param type Value which tells us which scene the key is for
   * @param resolution Resolution in which the image will be fetched in
   * @param floor Number of the floor of the image
   * @param row Number of the row of the image
   * @param column Number of the column of the
   */
  makeImageKey(type, resolution, floor, row, column) {
    return `${type}_${resolution}_${floor}_${row}_${column}`;
  }

  /**
   * Changes the passed rgba color aplha value to 1.
   * @param color Rgba color to be modified
   */
  removeAplhaFromColor(color) {
    if (!color) return "#192747";

    const checkRgbaPattern = /^^rgba[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*,){3}\s*0*(?:\.\d+|1(?:\.0*)?)\s*[)]$/g;
    const isRgba = color.match(checkRgbaPattern) ? true : false;

    const newColor = isRgba ? color.replace(/[\d\.]+\)$/g, '1)') : color;
    return newColor;
  }

  convertRGBtoOBJ(colorString) {
    if (colorString.includes('rgba')) {
      const rgbKeys = ['r', 'g', 'b', 'a'];
      let rgbObj = {};
      let color = colorString.replace(/^rgba?\(|\s+|\)$/g, '').split(',');

      for (let i in rgbKeys)
        rgbObj[rgbKeys[i]] = color[i] || 1;

      return [`rgb(${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b})`, rgbObj.a];
    }
    return [colorString, 1];
  }

  /**
   * Returns the first letter of the provided state key.
   * @param key Key of the State.
   */
  getLoadingStateIdentifier(key) {
    let apartmentOrBuildingIdentifier = key.split("_");
    return apartmentOrBuildingIdentifier[0];
  }

  /**
   * Method that finds first number in string. 
   * Returns true when it comes across the first number in string.
   * Returns false when string does not contain any number.
   * @param stringToCheck String we want to check if it contains number.
   */
  checkNumbersInSubstring(stringToCheck) {
    for (let i = 0; i < stringToCheck.length; i++) {
      const ch = stringToCheck[i];
      if (ch >= '0' && ch <= '9') {
        return true;
      }
    }
    return false;
  }

  parseStateNumber(stateString) {
    let string = [];
    // Loop thru all characters in string.
    for (let i = 0; i < stateString.length; i++) {
      let ch = stateString[i];
      // Char is number, add it to the array.
      if (ch >= '0' && ch <= '9') {
        string.push(ch);
      }
      // Came across character that is not number.
      else {
        // Take the substring from this element to the end.
        let newSubstring = stateString.substring(i, stateString.length);
        // Check if there are any more numbers in substring, if we previously found numbers (array.length).
        if (string.length > 0) {
          if (this.checkNumbersInSubstring(newSubstring)) {
            return stateString;
          }
        }
      }
    }

    // Remove all zeros from array that are infront of the number.
    for (let i = 0; i < string.length; i++) {
      const element = string[i];
      if (element === '0') string.shift();
      else break;
    }

    // Construct the number from Array of char.
    let newString = "";
    for (let i = 0; i < string.length; i++) {
      newString += string[i];
    }

    // Check if string is number.
    if (newString.length === 0 || isNaN(newString)) return stateString;
    return newString;

  }

  rgbStringToArray(rgbColorString) {
    if (rgbColorString.length !== 0) {
      let strokeColor = [];

      let strokeRgbStringFirstSplit = rgbColorString.split("rgb");
      let strokeRgbStringSecondSplit = strokeRgbStringFirstSplit[1].split(")")
      let strokeRgbStringThirddSplit = strokeRgbStringSecondSplit[0].split("(")
      let strokeRgbStringForthSplit = strokeRgbStringThirddSplit[1].split(",")

      let thenum = strokeRgbStringForthSplit[0].match(/\d+/)[0]
      let r = parseInt(thenum)
      let effectR = r / 255
      strokeColor.push(effectR)
      thenum = strokeRgbStringForthSplit[1].match(/\d+/)[0]
      let g = parseInt(thenum);
      let effectG = g / 255
      strokeColor.push(effectG);
      thenum = strokeRgbStringForthSplit[2].match(/\d+/)[0]
      let b = parseInt(thenum);
      let effectB = b / 255
      strokeColor.push(effectB);

      return strokeColor;
    } else return;
  }


}

export default new StringHelper();
